import React from 'react';
import { Typography } from '@mui/material';
import { getScoreMessage } from '../helpers';
import { ScoreStat } from './ScoreStat';

/**
 * How the answers broke down, shown beside the score ring. A perfect run swaps
 * the correct/incorrect counts for the congratulation headline.
 *
 * Props:
 *   id           (string) - ID prefix for generated element IDs.
 *   correctCount (number) - Questions answered correctly.
 *   total        (number) - Questions in the quiz.
 *   percentage   (number) - This attempt's score, 0 to 100.
 */
export const ScoreBreakdown = ({ id, correctCount, total, percentage }) => {
  if (percentage === 100) {
    return <Typography className="scoreHeadline">{getScoreMessage(percentage)}</Typography>;
  }

  return (
    <div className="scoreStats">
      <ScoreStat
        id={`${id}__stat_correct`}
        label="Correct"
        value={correctCount}
        variant="correct"
      />
      <ScoreStat
        id={`${id}__stat_incorrect`}
        label="Incorrect"
        value={total - correctCount}
        variant="incorrect"
      />
    </div>
  );
};
